function multiplyArray(a, x) {
    return a.map(num => num * x)
}

export { multiplyArray }